/**
 * @generated SignedSource<<43319b4ab367e6de3d963a201b0bc74e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StoreAvailability = "NONE" | "PRIVATE" | "PUBLIC";
import { FragmentRefs } from "relay-runtime";
export type StoreLinkedPackageModal_query$data = {
  readonly package: {
    readonly __typename: "MembershipPackage";
    readonly assignable: boolean;
    readonly club: {
      readonly timeZone: string;
    };
    readonly storeAvailability: StoreAvailability;
    readonly " $fragmentSpreads": FragmentRefs<"StorePackageModal_package" | "packageIsAvailableForSale_package">;
  } | {
    readonly __typename: "StandardPackage";
    readonly assignable: boolean;
    readonly club: {
      readonly timeZone: string;
    };
    readonly storeAvailability: StoreAvailability;
    readonly " $fragmentSpreads": FragmentRefs<"StorePackageModal_package" | "packageIsAvailableForSale_package">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly session: {
    readonly " $fragmentSpreads": FragmentRefs<"StorePackageModal_session">;
  } | null | undefined;
  readonly " $fragmentType": "StoreLinkedPackageModal_query";
};
export type StoreLinkedPackageModal_query$key = {
  readonly " $data"?: StoreLinkedPackageModal_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreLinkedPackageModal_query">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "assignable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "storeAvailability",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Club",
    "kind": "LinkedField",
    "name": "club",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "kind": "InlineDataFragmentSpread",
    "name": "packageIsAvailableForSale_package",
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DisplayInApp",
            "kind": "LinkedField",
            "name": "displayInApp",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "availableFrom",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "availableTo",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "Package",
        "abstractKey": "__isPackage"
      }
    ],
    "args": null,
    "argumentDefinitions": ([]/*: any*/)
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "StorePackageModal_package"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "packageId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoreLinkedPackageModal_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Session",
      "kind": "LinkedField",
      "name": "session",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StorePackageModal_session"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "package",
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "packageId"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "MembershipPackage",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "StandardPackage",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RootQueryType",
  "abstractKey": null
};
})();

(node as any).hash = "3e058556bdacd92f4cf35a1428b339c7";

export default node;
